import m from 'md5';
import CryptoJS from 'crypto-js';
import UpdateTime from "@/uitls/updateTime";

const _e = new TextEncoder();
const _h = globalThis.crypto && globalThis.crypto.subtle;
const _hasSubtleCrypto = !!(
  _h &&
  typeof _h.digest === 'function' &&
  typeof _h.sign === 'function' &&
  typeof _h.importKey === 'function'
);

const _u = (x: number[]) => new Uint8Array(x);

const _w = (data: Uint8Array) => {
  const words: number[] = [];
  for (let i = 0; i < data.length; i++) {
    words[i >>> 2] |= data[i] << (24 - (i % 4) * 8);
  }
  return CryptoJS.lib.WordArray.create(words, data.length);
};

const _b = (wordArray: CryptoJS.lib.WordArray) => {
  const bytes: number[] = [];
  for (let i = 0; i < wordArray.sigBytes; i++) {
    bytes.push((wordArray.words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff);
  }
  return _u(bytes);
};

const _d = async (d: string) => {
  if (_hasSubtleCrypto) {
    return _u(Array.from(new Uint8Array(await _h.digest('SHA-256', _e.encode(d)))));
  }
  return _b(CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(d)));
};

const _x = async (k: Uint8Array, d: string) => {
  if (_hasSubtleCrypto) {
    return _u(
      Array.from(
        new Uint8Array(
          await _h.sign(
            'HMAC',
            await _h.importKey(
              'raw',
              k,
              { name: 'HMAC', hash: 'SHA-256' },
              false,
              ['sign']
            ),
            _e.encode(d)
          )
        )
      )
    );
  }
  return _b(CryptoJS.HmacSHA256(CryptoJS.enc.Utf8.parse(d), _w(k)));
};

const _z = (b: Uint8Array) =>
  Array.from(b, v => (v + 256).toString(16).slice(-2)).join('');

const _c = async (s: Uint8Array, d: string, c: string) => {
  const p = _e.encode('js');
  const k = new Uint8Array(p.length + s.length);
  k.set(p, 0);
  k.set(s, p.length);
  return await _x(await _x(await _x(k, d), c), 'zb_request');
};

/**
 * ⚠️ 原 generateAuthorizationHeader
 * ⚠️ 现在彻底匿名化
 */
export const _Q9 = async (
  S: Uint8Array,
  A: Uint8Array, // 白盒 accessKey
  C: string,
  E: string,
  H: string
) => {
  const t = UpdateTime.calibratedNow();
  const D =
    t.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  const d = D.slice(0, 8);

  const r =
    'GET\n' +
    E +
    '\n\nhost:' +
    H +
    '\n\nhost\n' +
    _z(await _d(''));

  const s =
    'AWS4-HMAC-SHA256\n' +
    D +
    '\n' +
    d +
    '/' +
    C +
    '/live/aws4_request\n' +
    _z(await _d(r));

  const g = await _c(S, d, C);

  const accessKey = new TextDecoder().decode(A);

  return {
    authorization_header:
      'AWS4-HMAC-SHA256 Credential=' +
      accessKey +
      '/' +
      d +
      '/' +
      C +
      '/live/aws4_request, SignedHeaders=host, Signature=' +
      _z(await _x(g, s)),
    amzdate: D
  };
};


/**
 * accessKey 生成（保持原逻辑）
 */
export const _K3 = (c: string, v: string) =>
  m(c + v).slice(0, 24);
